module.exports = __webpack_public_path__ + "static/media/middle_school_zone.bbf147a1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/20-21/middle_school_zone.pdf
// module id = 213
// module chunks = 0